import * as Yup from "yup";
import { Moment } from "moment";

export const getFormInitValues = ({
  initStates,
  initMachines,
}: {
  initStates: string[];
  initMachines: string[];
}): {
  sampleDates: [Moment | null, Moment | null];
  states: string[];
  machines: string[];
} => ({
  sampleDates: [null, null],
  states: initStates,
  machines: initMachines,
});

export const formSchema = Yup.object().shape({
  states: Yup.array(),
  machines: Yup.array(),
});
